import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const apiGetCall = async (url: string, config: AxiosRequestConfig ={}) => {
    try {
      if (config.headers && config.headers.isPublic) {
        delete config.headers.isPublic;
        delete axios.defaults.headers.common["Authorization"]
      }
      const response = await axios.get(url, config);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  };
  
  export const apiPostCall = async (url: string, data: any, config: AxiosRequestConfig ={}) => {
    try {
      const response = await axios.post(url, data);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  };
  

export const apiPatchCall = async (url: string, data: any, config: AxiosRequestConfig = {}) => {
  try {
    const response: AxiosResponse<any> = await axios.patch(url, data, config);
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const apiPutCall = async (url: string, data: any, config: AxiosRequestConfig = {}) => {
  try {
    const response: AxiosResponse<any> = await axios.put(url, data, config);
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const apiDeleteCall = async (url: string, config: AxiosRequestConfig = {}) => {
  try {
    const response: AxiosResponse<any> = await axios.delete(url, config);
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};